import { useState } from "react";
import { motion } from "framer-motion";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { GALLERY } from "@/data/site";

export default function GalleryGrid({ compact = false }) {
  const [idx, setIdx] = useState(-1);
  const items = compact ? GALLERY.slice(0, 6) : GALLERY;

  return (
    <section className="py-24 md:py-36 bg-white" data-testid="gallery-section">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
          <div className="md:col-span-8">
            <div className="font-mono text-[11px] tracking-[0.28em] uppercase text-[color:var(--text-2)] mb-6">— Selected Work</div>
            <h2 className="font-display text-[44px] md:text-[86px] leading-[0.98] tracking-[-0.02em]">
              A closer look at what we <em className="italic text-[color:var(--accent)]">put on paper.</em>
            </h2>
          </div>
          <p className="md:col-span-4 text-[color:var(--text-2)] text-[16px] leading-[1.65] md:pb-3">
            Every project shown here is a real print run. Click any image to see it larger.
          </p>
        </div>

        <div className="mt-14 md:mt-20 grid grid-cols-2 md:grid-cols-4 auto-rows-[220px] md:auto-rows-[300px] gap-3 md:gap-4">
          {items.map((g, i) => {
            const spans = [
              "col-span-2 row-span-2",
              "col-span-1 row-span-1",
              "col-span-1 row-span-1",
              "col-span-1 row-span-2",
              "col-span-1 row-span-1",
              "col-span-2 row-span-1",
              "col-span-1 row-span-1",
              "col-span-1 row-span-1",
            ][i % 8];
            return (
              <motion.button
                key={i}
                onClick={() => setIdx(i)}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.7, delay: (i % 4) * 0.08 }}
                className={`relative group overflow-hidden rounded-xl bg-[color:var(--bg)] ${spans}`}
                data-testid={`gallery-item-${i}`}
              >
                <img
                  src={g.src}
                  alt={g.cat}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.08]"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-500" />
                <div className="absolute left-4 bottom-4 right-4 flex items-end justify-between opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500">
                  <span className="font-display italic text-white text-2xl md:text-3xl leading-none">{g.cat}</span>
                  <span className="font-mono text-white text-[10px] tracking-[0.24em] uppercase">↗ View</span>
                </div>
              </motion.button>
            );
          })}
        </div>
      </div>

      <Lightbox
        open={idx >= 0}
        close={() => setIdx(-1)}
        index={idx < 0 ? 0 : idx}
        slides={items.map((g) => ({ src: g.src, description: g.cat }))}
      />
    </section>
  );
}
